// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import config from './config'
import router from './router'
import store from './store'
import './database'
import './plugins'
import './filters'
import i18n from '@/plugins/i18n'
import vuetify from '@/plugins/vuetify'
// import './extensions/datalogic'
import routes from '@/router/routes'
import App from './components/App.vue'
import Acl from '@/roles'
import '@/assets/style.scss'

// Register commonly used components
import '@/components/shared'

import HelpAbbr from '@/components/help/HelpAbbr'
import HelpTooltip from '@/components/help/HelpTooltip'
import OpenHelpBtn from '@/components/help/OpenHelpBtn'

Vue.config.productionTip = false

Vue.use(Acl)

// global components
Vue.component('help-abbr', HelpAbbr)
Vue.component('help-tooltip', HelpTooltip)
Vue.component('open-help-btn', OpenHelpBtn)

// Set title to app name
document.title = config.title

// Add routes now to avoid circular import
router.addRoutes(routes)

/* eslint-disable no-new */
new Vue({
  el: '#root',
  i18n,
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
